module.exports = __webpack_public_path__ + "static/media/profilepic.161b18eb.png";